module.exports = __webpack_public_path__ + "static/img/top.42f8bda6.png";